;(function () {
  'use strict'

  angular.module('contrast.auth').factory('logoutService', logoutServiceFactory)

  function logoutServiceFactory(
    $window,
    AuthService,
    URLHistoryService,
    ServiceUtils,
    LOGOUT_BASE_URL,
    LOGOUT_REDIRECT,
    $http,
    $rootScope,
    AUTH_EVENTS
  ) {
    'ngInject'
    function logoutWithoutRedirect() {
      $http.get(LOGOUT_BASE_URL)
    }
    const logoutListener = $rootScope.$on(
      AUTH_EVENTS.TRIGGER_LOGOUT,
      logoutWithoutRedirect
    )

    $rootScope.$on('$destroy', function () {
      logoutListener()
    })

    return {
      logoutWithoutRedirect,
      logout: logout
    }

    /**
     * @param {{}} [opts]
     * @param {{}} [opts.redirectParams] Key/value pairs to be added as URL params to the redirect page
     * @param {boolean} [opts.redirectToSignin]
     */
    function logout(opts) {
      if (!angular.isObject(opts)) {
        opts = {}
      }
      AuthService.setAuthenticated(false)
      URLHistoryService.clearPreviousUrl()
      var url = LOGOUT_BASE_URL + '?target='
      if (opts.redirectToSignin) {
        url += LOGOUT_REDIRECT.SIGNIN
      } else {
        url += LOGOUT_REDIRECT.LOGOUT
      }
      if (angular.isObject(opts) && angular.isObject(opts.redirectParams)) {
        url += ServiceUtils.buildParamsString(opts.redirectParams)
      }
      $window.location.href = url
    }
  }
})()
